/**
 * Client-side debug logging.
 * At the moment this simply logs to the browser console, but it's still useful to have dedicated
 * methods to allow collecting them in the future, or silencing them in production or in mocha
 * tests.
 */

export type LogMethod = (message: string, ...args: any[]) => void;

// tslint:disable:no-console
export const debug: LogMethod = () => {};
export const info: LogMethod = () => {};
export const log: LogMethod = () => {};
export const warn: LogMethod = () => {};
export const error: LogMethod = console.error.bind(console);
